<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="save"
                            :loading="dataset.loading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataset.loading" v-if="!page.isNew">Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/manutencoes/fornecedores">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Dados da empresa</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="8">
                                    <v-text-field dense outlined label="Razão social / Nome"
                                        v-model="dataset.data.company_name" :rules="[$rules.required]"
                                        hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined label="CNPJ"
                                        v-model="dataset.data.cnpj" :rules="[$rules.required]"
                                        v-mask="'##.###.###/####-##'" hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined label="E-mail" type="email"
                                        v-model="dataset.data.email" hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined label="Telefone"
                                        v-model="dataset.data.phone_number"
                                        v-mask="['(##) ####-####', '(##) #####-####']"
                                        hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Endereço</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="8">
                                    <v-text-field dense outlined label="Rua / Logradouro"
                                        v-model="dataset.data.street" :rules="[$rules.required]"
                                        hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined label="Complemento"
                                        v-model="dataset.data.complement" hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined label="Cidade"
                                        v-model="dataset.data.city" :rules="[$rules.required]"
                                        hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-select dense outlined label="Estado" v-model="dataset.data.state"
                                        :items="states" :rules="[$rules.required]"
                                        hide-details="auto"></v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import axios from 'axios'

export default {
    name: 'SupplierDetails',

    data: () => ({
        page: {
            title: '',
            isNew: true,
        },
        dataset: {
            data: {
                company_name: '',
                cnpj: '',
                email: '',
                phone_number: '',
                street: '',
                complement: '',
                city: '',
                state: '',
            },
            breadcrumbItems: [],
            loading: false,
        },
        dataForm: {
            validForm: true,
        },
        states: [
            'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO',
            'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
            'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
        ],
    }),

    created() {
        this.loadData()
    },

    methods: {
        async loadData() {
            this.setPage()
            this.listBreadCrumbItems()

            if (!this.page.isNew) {
                await this.load()
            }
        },

        goBack() {
            this.$router.replace('/manutencoes/fornecedores')
        },

        setPage() {
            this.page.isNew = this.$route.params.id === 'novo'
            this.page.title = this.page.isNew ? 'Novo fornecedor' : 'Editar fornecedor'
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                { text: 'Homepage', disabled: false, to: '/home', exact: true },
                { text: 'Manutenções', disabled: false, to: '/manutencoes', exact: true },
                { text: 'Fornecedores', disabled: false, to: '/manutencoes/fornecedores', exact: true },
                { text: this.page.isNew ? 'Novo fornecedor' : 'Editar fornecedor', disabled: true, exact: true },
            ]
        },

        cleanCnpj(cnpj) {
            return (cnpj || '').replace(/\D/g, '')
        },

        cleanPhone(phone) {
            return (phone || '').replace(/\D/g, '')
        },

        async load() {
            this.dataset.loading = true
            try {
                const { data } = await axios.get(`/api/suppliers/${this.$route.params.id}`)
                const item = data || {}

                this.dataset.data = {
                    company_name: item.company_name || '',
                    cnpj: item.cnpj || '',
                    email: item.email || '',
                    phone_number: item.phone_number || '',
                    street: item.street || '',
                    complement: item.complement || '',
                    city: item.city || '',
                    state: item.state || '',
                }
            } catch (error) {
                this.$dialog.notify.error('Erro ao carregar o fornecedor.', { position: 'top-right', timeout: 5000 })
            } finally {
                this.dataset.loading = false
            }
        },

        buildPayload() {
            const cleanCnpj = this.cleanCnpj(this.dataset.data.cnpj)
            return {
                company_name: this.dataset.data.company_name,
                cnpj: cleanCnpj,
                email: this.dataset.data.email || null,
                phone_number: this.cleanPhone(this.dataset.data.phone_number) || null,
                street: this.dataset.data.street,
                complement: this.dataset.data.complement || null,
                city: this.dataset.data.city,
                state: this.dataset.data.state,
            }
        },

        async save() {
            if (!this.$refs.form.validate()) return

            const cleanCnpj = this.cleanCnpj(this.dataset.data.cnpj)
            if (!cleanCnpj || cleanCnpj.length !== 14) {
                this.$dialog.notify.error('Informe um CNPJ válido com 14 dígitos.', { position: 'top-right', timeout: 5000 })
                return
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja salvar o fornecedor?',
                title: 'Salvar fornecedor',
                actions: { false: 'Cancelar', true: 'Salvar' },
            })

            if (!proceedAction) return

            this.dataset.loading = true

            try {
                await axios.post('/api/suppliers', this.buildPayload())

                this.$dialog.notify.info('Fornecedor criado com sucesso.', { position: 'top-right', timeout: 2000 })

                this.goBack()
            } catch (error) {
                const msg = error?.response?.data?.message || error?.response?.data?.[0]?.message
                this.$dialog.notify.error(msg || (this.$codes ? this.$codes(error) : 'Erro ao salvar fornecedor.'), {
                    position: 'top-right', timeout: 5000,
                })
            } finally {
                this.dataset.loading = false
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return

            const cleanCnpj = this.cleanCnpj(this.dataset.data.cnpj)
            if (!cleanCnpj || cleanCnpj.length !== 14) {
                this.$dialog.notify.error('Informe um CNPJ válido com 14 dígitos.', { position: 'top-right', timeout: 5000 })
                return
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o fornecedor?',
                title: 'Atualizar fornecedor',
                actions: { false: 'Cancelar', true: 'Atualizar' },
            })

            if (!proceedAction) return

            this.dataset.loading = true

            try {
                await axios.patch(`/api/suppliers/${this.$route.params.id}`, this.buildPayload())

                this.$dialog.notify.info('Fornecedor atualizado com sucesso.', { position: 'top-right', timeout: 2000 })

                this.goBack()
            } catch (error) {
                const msg = error?.response?.data?.message || error?.response?.data?.[0]?.message
                this.$dialog.notify.error(msg || (this.$codes ? this.$codes(error) : 'Erro ao atualizar fornecedor.'), {
                    position: 'top-right', timeout: 5000,
                })
            } finally {
                this.dataset.loading = false
            }
        },
    },
}
</script>
